import controlPanelSharedStyle from "../../../Common/controlPanelSharedStyle";

const CommonStyle = `
  html,body,#root,#gsk_version,section{height:100%;}
  body{overflow:auto !important}
  .modal-open .modal{padding-right:0 !important;}
  .swiper-pagination {
    position: absolute;
    text-align: center;
    transition: 300ms opacity;
    transform: translate3d(0, 0, 0);
    z-index: 10;
  }
  .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 4px;
  }
  .swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer;
  }
  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 50%;
    background: #000;
    opacity: 0.2;
  }
  
  .content-area {
    height:100%;
    box-sizing: border-box;
    margin-bottom:100px;
  }
  .livebtn {
    position: relative;
    display: inline-block;
    text-align: center;
    background: #FF7373;
    border-radius: 2px;
    box-sizing: border-box;

  }
  .livebtn small {
    display: block;
    width: 100%;
    padding:0 4px;
    color: #fff;
    font-size: 10px;
    line-height:14px;
    font-weight: 400;
  }
  
  .ondemandbtn {
    position: relative;
    display: inline-block;
    text-align: center;
    background: #8F8FFF;
    border-radius: 2px;
    box-sizing: border-box;
  }
  .ondemandbtn small {
    display: block;
    width: 100%;
    padding:0 4px;
    color: #fff;
    font-size: 10px;
    line-height:14px;
    font-weight: 400;
  }
  .basic_btn {
    width: 160px;
    height: 60px;
    line-height: 60px;
    background: #6a6af8;
    border-radius: 4px;
    color: #fff;
    font-size: 15px;
  }
  .jw-state-idle .jw-controls {
    background: rgba(0, 0, 0, 0) !important;
  }

  ${controlPanelSharedStyle}

  
`

export default CommonStyle;
